import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginPopup from './login-popup';

const LoginPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <LoginPopup onClose={() => navigate('/', { replace: true })} />
    </div>
  );
};

export default LoginPage;